import type { FC } from 'react';
import React, { memo } from 'react';

import { ShortcutListener, ShortcutType } from './ShortcutListener.tsx';
import { AppNavigationShortcut } from './AppNavigationShortcut.tsx';
import { useKeyboardShortcutsEnabled } from './useKeyboardShortcutsEnabled.ts';

type GeneralShortcutListenerProps = {
	accelerator: string | string[];
	deprecatedAccelerator?: string | string[];
	listener(e: KeyboardEvent): void;
	isAppNavigationShortcut?: boolean;
	shortcutType?: ShortcutType;
	allowInDialog?: boolean;
};

export const GeneralShortcutListener: FC<GeneralShortcutListenerProps> = memo(
	({
		accelerator,
		deprecatedAccelerator,
		listener,
		isAppNavigationShortcut = false,
		shortcutType = ShortcutType.Confluence,
		allowInDialog = false,
	}) => {
		const [areGeneralShortcutsEnabled] = useKeyboardShortcutsEnabled();

		if (!areGeneralShortcutsEnabled) return null;

		return isAppNavigationShortcut ? (
			<AppNavigationShortcut
				accelerator={accelerator}
				deprecatedAccelerator={deprecatedAccelerator}
				listener={listener}
			/>
		) : (
			<ShortcutListener
				accelerator={accelerator}
				deprecatedAccelerator={deprecatedAccelerator}
				listener={listener}
				shortcutType={shortcutType}
				allowInDialog={allowInDialog}
			/>
		);
	},
);
